
/**
 * 贴地距离测量
 */

import DrawPolyline from "../plot/DrawPolyline"
import ConstantDraw from "../constants/ConstantDraw"
import { computeSurfaceLine, getSpace, getDistanceText } from "./utils/index"
class DistanceGround extends DrawPolyline {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        if (l == 2) {
            var lable = ConstantDraw.Style_Label;
            lable.pixelOffset=new Cesium.Cartesian2(0.0, -20.0);
            lable.text = "起点";
            var p = this.createPoint($this.positions[0], ConstantDraw.Style_KeyPos);
            this.entitiesLabel.push(p);
            this.entities.push(p);
            p.label = lable;
        }
        if (l > 2) {

            var start = $this.positions[l - 3];
            var end = $this.positions[l - 2];
            var dis = getSpace(start, end);
            var disTxt = getDistanceText(dis);
            this.sum += dis;
            var sumTxt = getDistanceText(this.sum);
            var lable = ConstantDraw.Style_Label;
            lable.pixelOffset=new Cesium.Cartesian2(0.0, -30.0);
            lable.text = `+${disTxt}\n总长:${sumTxt}`
            var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
            this.entitiesLabel.push(p);
            this.entities.push(p);
            p.label = lable;
        }
    }

    initEditor() {
        this.plot.entitiesLabel= this.entitiesLabel;
    }

    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var start = $this.positions[l - 2];
        var end = $this.positions[l - 1];
        var dis = getSpace(start, end);
        var disTxt = getDistanceText(dis);
        this.sum += dis;
        var sumTxt = getDistanceText(this.sum);
        var lable = ConstantDraw.Style_Label;
        lable.pixelOffset=new Cesium.Cartesian2(0.0, -30.0);
        lable.text = `+${disTxt}\n总长:${sumTxt}`
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        this.entities.push(p);
        p.label = lable;

        // var $this = this;
        this.sum = 0;
        function* generator() {
            for (let i = 0; i < $this.entitiesLabel.length-1; i++) {
                var start = $this.entitiesLabel[i].position.getValue();
                var end = $this.entitiesLabel[i + 1].position.getValue();

                yield new Promise((resolve, reject) => {
                    // 这里是异步操作的代码
                    // 如果异步操作成功，调用 resolve 并传递结果
                    // 如果异步操作失败，调用 reject 并传递错误信息
                    computeSurfaceLine({
                        scene: $this.viewer.scene,
                        positions: [start, end],
                        splitNum:150,
                        //minDistance:15,//按照15米插值
                        calback: (raisedPositions, noHeight, positions) => {
                            var subSum = 0;
                            for (let i = 0; i < raisedPositions.length - 1; i++) {
                                var a = raisedPositions[i];
                                var b = raisedPositions[i + 1];
                                var dis = getSpace(a, b);
                                subSum += dis;
                            }
                            var p = $this.entitiesLabel[i + 1];
                            resolve({subSum, p});
                        }
                    });
                });
            }
        }

        function run(res) {
            if (!res.done) {
                res.value
                    .then(({subSum, p}) => {
                        $this.sum += subSum;
                        var disTxt = getDistanceText(subSum);
                        var sumTxt = getDistanceText($this.sum);
                        var lable = ConstantDraw.Style_Label;
                        lable.text = `+${disTxt}\n总长:${sumTxt}`
                        if(p){
                            p.label = lable;
                        }
                        run(gen.next());
                    });
            }
        }

        let gen = generator();
        run(gen.next());

        super.rightClick(evt); //调用
    }

    leftDoubleClick_back(evt) {
        super.leftDoubleClick(evt);
        var $this = this;
        this.sum = 0;
        function* generator() {
            for (let i = 0; i < $this.entitiesLabel.length - 1; i++) {
                var start = $this.entitiesLabel[i].position.getValue();
                var end = $this.entitiesLabel[i + 1].position.getValue();

                yield new Promise((resolve, reject) => {
                    // 这里是异步操作的代码
                    // 如果异步操作成功，调用 resolve 并传递结果
                    // 如果异步操作失败，调用 reject 并传递错误信息
                    computeSurfaceLine({
                        scene: $this.viewer.scene,
                        positions: [start, end],
                        //minDistance:15,//按照15米插值
                        calback: (raisedPositions, noHeight, positions) => {
                            var subSum = 0;
                            for (let i = 0; i < raisedPositions.length - 1; i++) {
                                var a = raisedPositions[i];
                                var b = raisedPositions[i + 1];
                                var dis = getSpace(a, b);
                                subSum += dis;
                            }
                            var p = $this.entitiesLabel[i + 1];
                            resolve({subSum, p});
                        }
                    });
                });
            }
        }

        function run(res) {
            if (!res.done) {
                res.value
                    .then(({subSum, p}) => {
                        $this.sum += subSum;
                        var disTxt = getDistanceText(subSum);
                        var sumTxt = getDistanceText($this.sum);
                        var lable = ConstantDraw.Style_Label;
                        lable.text = `+${disTxt}\n总长:${sumTxt}`
                        p.label = lable;
                        run(gen.next());
                    });
            }
        }

        let gen = generator();
        run(gen.next());

        // for (let i = 0; i < this.entitiesLabel.length - 1; i++) {
        //     var start = this.entitiesLabel[i].position.getValue();
        //     var end = this.entitiesLabel[i + 1].position.getValue();
        //     computeSurfaceLine({
        //         scene: $this.viewer.scene,
        //         positions: [start, end],
        //         //minDistance:15,//按照15米插值
        //         calback: (raisedPositions, noHeight, positions) => {
        //             var subSum = 0;
        //             for (let i = 0; i < raisedPositions.length - 1; i++) {
        //                 var a = raisedPositions[i];
        //                 var b = raisedPositions[i + 1];
        //                 var dis = getSpace(a, b);
        //                 subSum += dis;
        //             }
        //             this.sum += subSum;
        //             var disTxt = getDistanceText(subSum);
        //             var sumTxt = getDistanceText(this.sum);
        //             var lable = ConstantDraw.Style_Label;
        //             lable.text = `+${disTxt}\n总长:${sumTxt}`
        //             var p = this.entitiesLabel[i + 1];
        //             p.label = lable;

        //         }
        //     });
        // }
    }

    // leftDoubleClick(evt) {
    //     super.leftDoubleClick(evt);
    //     var $this = this;
    //     this.sum = 0;
    //     for (let i = 0; i < this.entitiesLabel.length - 1; i++) {
    //         var start = this.entitiesLabel[i].position.getValue();
    //         var end = this.entitiesLabel[i + 1].position.getValue();
    //         computeSurfaceLine({
    //             scene: $this.viewer.scene,
    //             positions: [start, end],
    //             //minDistance:15,//按照15米插值
    //             calback: (raisedPositions, noHeight, positions) => {
    //                 var subSum = 0;
    //                 for (let i = 0; i < raisedPositions.length - 1; i++) {
    //                     var a = raisedPositions[i];
    //                     var b = raisedPositions[i + 1];
    //                     var dis = getSpace(a, b);
    //                     subSum += dis;
    //                 }
    //                 this.sum += subSum;
    //                 var disTxt = getDistanceText(subSum);
    //                 var sumTxt = getDistanceText(this.sum);
    //                 var lable = ConstantDraw.Style_Label;
    //                 lable.text = `+${disTxt}\n总长:${sumTxt}`
    //                 var p = this.entitiesLabel[i + 1];
    //                 p.label = lable;

    //             }
    //         });
    //     }
    // }
    reset() {
        super.reset();
        this.sum = 0;
        this.entitiesLabel = [];
    }
}

export default DistanceGround